import { render, staticRenderFns } from "./ListCustomerAverageVotes.vue?vue&type=template&id=709583df&scoped=true&"
import script from "./ListCustomerAverageVotes.vue?vue&type=script&lang=js&"
export * from "./ListCustomerAverageVotes.vue?vue&type=script&lang=js&"
import style0 from "./ListCustomerAverageVotes.vue?vue&type=style&index=0&id=709583df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709583df",
  null
  
)

export default component.exports